
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({})
export default class SuccessOperationPage extends Vue {
  // private message: string = 'Your operation was successful!';

  private get message() {
    return this.$route.query.message || 'Thank you';
  }
}
